module.exports = require("utils-library/dist/db-entity-interfaces");